/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var vuex_esmBundler = require('./vuex.esm-bundler-607ad4c2.js');
var normalizeComponent = require('./normalize-component-d885d5ff.js');

var __nuxt = process && !!process.env.isNuxt;
var __mapState = __nuxt ? vuex_esmBundler.mapState({
  theme: function theme(state) {
    return state.theme;
  },
  colors: function colors(state) {
    return state.colors;
  }
}) : vuex_esmBundler.mapState({
  theme: function theme(state) {
    return state.common.theme;
  },
  colors: function colors(state) {
    return state.common.colors;
  }
});
var store_theme = __nuxt ? 'SET_THEME' : 'common/THEME';
var store_colors = __nuxt ? 'COLORS' : 'common/COLORS';
var script = {
  name: "ThemeContent",
  data: function data() {
    return {
      visible: false,
      list: []
    };
  },
  props: {
    isMenu: {
      type: Boolean,
      default: false
    }
  },
  computed: vuex_esmBundler._objectSpread2({}, __mapState),
  mounted: function mounted() {},
  methods: {
    changeTheme: function changeTheme() {
      var __theme = this.theme == 'black' ? 'white' : 'black';
      this.$store.commit(store_theme, __theme);
      this.$localStore.set('theme', __theme);
    },
    changeColors: function changeColors(colors) {
      this.$store.commit(store_colors, colors);
      this.$localStore.set('colors', colors);
    }
  }
};

var img$1 = "data:image/svg+xml,%3csvg width='52' height='30' viewBox='0 0 52 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.1679 0.0891791C17.942 -0.00759461 19.7141 0.000147289 21.4882 0.000147289C21.5005 0.000147289 30.4781 0.000147289 30.4781 0.000147289C32.2869 0.000147289 34.059 -0.00759461 35.8321 0.0891791C37.4441 0.176275 39.0143 0.362081 40.5773 0.77724C43.8676 1.65014 46.7409 3.47336 48.8178 6.05818C50.8825 8.62656 52 11.7707 52 14.9991C52 18.2313 50.8825 21.3736 48.8178 23.942C46.7409 26.5258 43.8676 28.35 40.5773 29.2229C39.0143 29.6381 37.4441 29.8229 35.8321 29.911C34.059 30.0077 32.2869 29.999 30.5128 29.999C30.5006 29.999 21.5209 30 21.5209 30C19.7141 29.999 17.942 30.0077 16.1679 29.911C14.5569 29.8229 12.9867 29.6381 11.4237 29.2229C8.13341 28.35 5.26016 26.5258 3.18322 23.942C1.11851 21.3736 0 18.2313 0 15.0001C0 11.7707 1.11851 8.62656 3.18322 6.05818C5.26016 3.47336 8.13341 1.65014 11.4237 0.77724C12.9867 0.362081 14.5569 0.176275 16.1679 0.0891791Z' fill='%232C2C2F'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M37 28C44.1797 28 50 22.1797 50 15C50 7.8203 44.1797 2 37 2C29.8203 2 24 7.8203 24 15C24 22.1797 29.8203 28 37 28Z' fill='%23141414'/%3e%3cg clip-path='url(%23clip0_2092_33972)'%3e%3cpath d='M35.185 6.865C34.5435 8.25755 34.3442 9.81326 34.6139 11.3226C34.8837 12.8318 35.6095 14.2222 36.6936 15.3064C37.7778 16.3905 39.1681 17.1163 40.6774 17.3861C42.1867 17.6558 43.7424 17.4565 45.135 16.815C44.3067 20.545 40.9792 23.3333 37 23.3333C32.3975 23.3333 28.6667 19.6025 28.6667 15C28.6667 11.0208 31.455 7.69333 35.185 6.865ZM42.1367 6.90917L42.8333 7.08333V7.91667L42.1367 8.09083C41.8437 8.16411 41.5761 8.31563 41.3625 8.52919C41.149 8.74275 40.9974 9.01033 40.9242 9.30333L40.75 10H39.9167L39.7425 9.30333C39.6692 9.01033 39.5177 8.74275 39.3041 8.52919C39.0906 8.31563 38.823 8.16411 38.53 8.09083L37.8333 7.91667V7.08333L38.53 6.90917C38.8228 6.83576 39.0902 6.68418 39.3036 6.47063C39.5171 6.25707 39.6684 5.98956 39.7417 5.69667L39.9167 5H40.75L40.9242 5.69667C40.9974 5.98967 41.149 6.25725 41.3625 6.47081C41.5761 6.68437 41.8437 6.83589 42.1367 6.90917ZM46.3033 11.0758L47 11.25V12.0833L46.3033 12.2575C46.0103 12.3308 45.7427 12.4823 45.5292 12.6959C45.3156 12.9094 45.1641 13.177 45.0908 13.47L44.9167 14.1667H44.0833L43.9092 13.47C43.8359 13.177 43.6844 12.9094 43.4708 12.6959C43.2572 12.4823 42.9897 12.3308 42.6967 12.2575L42 12.0833V11.25L42.6967 11.0758C42.9897 11.0026 43.2572 10.851 43.4708 10.6375C43.6844 10.4239 43.8359 10.1563 43.9092 9.86333L44.0833 9.16667H44.9167L45.0908 9.86333C45.1641 10.1563 45.3156 10.4239 45.5292 10.6375C45.7427 10.851 46.0103 11.0026 46.3033 11.0758Z' fill='%2383838E'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_2092_33972'%3e%3crect width='20' height='20' fill='white' transform='translate(27 5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='52' height='30' viewBox='0 0 52 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.1679 0.0891791C17.942 -0.00759461 19.7141 0.000147289 21.4882 0.000147289C21.5005 0.000147289 30.4781 0.000147289 30.4781 0.000147289C32.2869 0.000147289 34.059 -0.00759461 35.8321 0.0891791C37.4441 0.176275 39.0143 0.362081 40.5773 0.77724C43.8676 1.65014 46.7409 3.47336 48.8178 6.05818C50.8825 8.62656 52 11.7707 52 14.9991C52 18.2313 50.8825 21.3736 48.8178 23.942C46.7409 26.5258 43.8676 28.35 40.5773 29.2229C39.0143 29.6381 37.4441 29.8229 35.8321 29.911C34.059 30.0077 32.2869 29.999 30.5128 29.999C30.5006 29.999 21.5209 30 21.5209 30C19.7141 29.999 17.942 30.0077 16.1679 29.911C14.5569 29.8229 12.9867 29.6381 11.4237 29.2229C8.13341 28.35 5.26016 26.5258 3.18322 23.942C1.11851 21.3736 0 18.2313 0 15.0001C0 11.7707 1.11851 8.62656 3.18322 6.05818C5.26016 3.47336 8.13341 1.65014 11.4237 0.77724C12.9867 0.362081 14.5569 0.176275 16.1679 0.0891791Z' fill='%23ECF1F4'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M15 28C22.1797 28 28 22.1797 28 15C28 7.8203 22.1797 2 15 2C7.8203 2 2 7.8203 2 15C2 22.1797 7.8203 28 15 28Z' fill='white'/%3e%3cg clip-path='url(%23clip0_2092_33973)'%3e%3cpath d='M15 20C13.6739 20 12.4022 19.4732 11.4645 18.5355C10.5268 17.5978 10 16.3261 10 15C10 13.6739 10.5268 12.4021 11.4645 11.4644C12.4022 10.5268 13.6739 9.99998 15 9.99998C16.3261 9.99998 17.5979 10.5268 18.5355 11.4644C19.4732 12.4021 20 13.6739 20 15C20 16.3261 19.4732 17.5978 18.5355 18.5355C17.5979 19.4732 16.3261 20 15 20ZM15 18.3333C15.8841 18.3333 16.7319 17.9821 17.357 17.357C17.9822 16.7319 18.3333 15.884 18.3333 15C18.3333 14.1159 17.9822 13.2681 17.357 12.643C16.7319 12.0178 15.8841 11.6666 15 11.6666C14.116 11.6666 13.2681 12.0178 12.643 12.643C12.0179 13.2681 11.6667 14.1159 11.6667 15C11.6667 15.884 12.0179 16.7319 12.643 17.357C13.2681 17.9821 14.116 18.3333 15 18.3333ZM14.1667 5.83331H15.8333V8.33331H14.1667V5.83331ZM14.1667 21.6666H15.8333V24.1666H14.1667V21.6666ZM7.92918 9.10748L9.10751 7.92915L10.875 9.69665L9.69668 10.875L7.92918 9.10831V9.10748ZM19.125 20.3033L20.3033 19.125L22.0708 20.8925L20.8925 22.0708L19.125 20.3033ZM20.8925 7.92831L22.0708 9.10748L20.3033 10.875L19.125 9.69665L20.8925 7.92915V7.92831ZM9.69668 19.125L10.875 20.3033L9.10751 22.0708L7.92918 20.8925L9.69668 19.125ZM24.1667 14.1666V15.8333H21.6667V14.1666H24.1667ZM8.33334 14.1666V15.8333H5.83334V14.1666H8.33334Z' fill='%238C8CA2'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_2092_33973'%3e%3crect width='20' height='20' fill='white' transform='translate(5 5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

/* script */
const __vue_script__ = script;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    !_vm.isMenu
      ? _c(
          "div",
          {
            staticClass: "divider-bm",
            attrs: { slot: "title" },
            slot: "title",
          },
          [
            _c("div", { staticClass: "text-style-body-400 title-theme" }, [
              _vm._v(_vm._s(_vm.$t("usdt_88"))),
            ]),
            _vm._v(" "),
            _vm.theme == "black"
              ? _c("img", {
                  staticClass: "pointer",
                  attrs: { src: img$1 },
                  on: { click: _vm.changeTheme },
                })
              : _c("img", {
                  staticClass: "pointer",
                  attrs: { src: img },
                  on: { click: _vm.changeTheme },
                }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isMenu
      ? _c("h2", { staticClass: "quote-color" }, [
          _vm._v(_vm._s(_vm.$t("usdt_89"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "bottom-wrap" }, [
      _c("h3", { staticClass: "text-style-body-400 up-down" }, [
        _vm._v(_vm._s(_vm.$t("usdt_90"))),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "flex flex-wrap" }, [
        _c(
          "li",
          {
            staticClass: "card-item",
            class: _vm.colors == "classic-reverse" && "active",
            on: {
              click: function ($event) {
                return _vm.changeColors("classic-reverse")
              },
            },
          },
          [
            _c("div", [
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_104")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_105")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-col" }, [
              _c(
                "svg",
                {
                  staticClass: "card-icon classic-red-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-up" } })]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "card-icon classic-green-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-down" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "card-item",
            class: _vm.colors == "classic" && "active",
            on: {
              click: function ($event) {
                return _vm.changeColors("classic")
              },
            },
          },
          [
            _c("div", [
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_91")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_92")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-col" }, [
              _c(
                "svg",
                {
                  staticClass: "card-icon classic-green-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-up" } })]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "card-icon classic-red-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-down" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "card-item",
            class: _vm.colors == "cva-reverse" && "active",
            on: {
              click: function ($event) {
                return _vm.changeColors("cva-reverse")
              },
            },
          },
          [
            _c("div", [
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_102")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_105")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-col" }, [
              _c(
                "svg",
                {
                  staticClass: "card-icon cva-red-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-up" } })]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "card-icon cva-green-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-down" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "card-item",
            class: _vm.colors == "cva" && "active",
            on: {
              click: function ($event) {
                return _vm.changeColors("cva")
              },
            },
          },
          [
            _c("div", [
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_91")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("usdt_103")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-col" }, [
              _c(
                "svg",
                {
                  staticClass: "card-icon cva-green-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-up" } })]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "card-icon cva-red-100",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#bf-trend-down" } })]
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-dd776dcc";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

exports.__vue_component__ = __vue_component__;
exports.img = img$1;
exports.img$1 = img;
